import styled, { withTheme } from 'foundations-theming/utils';
import I18n from 'I18n';
import { Component } from 'react';
import UIFileAttachment from 'UIComponents/attachment/UIFileAttachment';
import { NanoProgress } from 'foundations-components/transitional/components/NanoProgress';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedSize from 'I18n/components/FormattedSize';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { FILE_SIZE, UNSUPPORTED_TYPE } from 'composer-data/file-uploads/public/constants';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const FileAttachment = styled(UIFileAttachment).withConfig({
  displayName: "AttachmentPreview__FileAttachment",
  componentId: "hqvitp-0"
})(["margin-left:12px;max-width:200px !important;div:first-of-type{padding-right:12px;}&:last-of-type{margin-right:12px;}"]);
class AttachmentPreviewWithoutTheme extends Component {
  constructor(props) {
    super(props);
    this.renderAttachment = this.renderAttachment.bind(this);
  }
  isUploading() {
    return this.props.uploadProgress < 100;
  }
  renderErrorMessage(error) {
    if (!error) return null;
    if (error.attachmentErrorType === FILE_SIZE && error.maxFileSize) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.attachment.errors.file-size-error",
        options: {
          maxFileSize: I18n.formatSize(error.maxFileSize)
        }
      });
    }
    if (error.attachmentErrorType === UNSUPPORTED_TYPE) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.attachment.errors.unsupported-type-error"
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.attachment.errors.default"
    });
  }
  renderFileInfo() {
    if (!this.isUploading()) {
      return /*#__PURE__*/_jsx(FormattedSize, {
        value: this.props.size
      });
    }
    const uploadedBytes = this.props.size * this.props.uploadProgress / 100;
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.attachment.upload-progress",
      options: {
        uploadedBytes: I18n.formatSize(uploadedBytes, {
          precision: 2,
          strip_insignificant_zeroes: true
        }),
        totalBytes: I18n.formatSize(this.props.size)
      }
    });
  }
  renderProgress() {
    if (!this.isUploading()) {
      return null;
    }
    return /*#__PURE__*/_jsx(NanoProgress, {
      boxShadow: false,
      value: this.props.uploadProgress
    });
  }
  renderAttachment() {
    const {
      name,
      error
    } = this.props;
    return /*#__PURE__*/_jsx(Tooltip, {
      title: this.renderErrorMessage(error),
      children: /*#__PURE__*/_jsx(FileAttachment, {
        "data-test-id": "file-attachment-preview",
        closeable: true,
        onCloseClick: this.props.removeAttachment,
        fileName: name,
        fileInfo: this.renderFileInfo(),
        renderPreview: this.props.preview,
        processing: this.isUploading(),
        style: error ? {
          backgroundColor: this.props.theme.color['do-not-use-candy-apple-light'],
          border: `1px solid ${this.props.theme.color['do-not-use-candy-apple']}`
        } : {},
        children: !error ? this.renderProgress() : null
      }, name)
    });
  }
  render() {
    return /*#__PURE__*/_jsx(View, {
      paddingBlock: "300",
      as: "div",
      children: this.renderAttachment()
    });
  }
}
AttachmentPreviewWithoutTheme.displayName = 'AttachmentPreview';
AttachmentPreviewWithoutTheme.defaultProps = {
  uploadProgress: 100
};
const AttachmentPreview = withTheme(AttachmentPreviewWithoutTheme);
export default AttachmentPreview;